import {ResolveFn} from '@angular/router';
import {inject} from "@angular/core";
import {ApiService} from "@app/_services/api.service";
import {catchError, forkJoin, map, of} from "rxjs";

export const auditLogResolver: ResolveFn<any> = () => {
    const apiService = inject(ApiService);
    // A failed list leaves its filter empty instead of blocking the page; failedLists names it for a warning.
    return forkJoin({
        customers: apiService.getCustomers().pipe(catchError(() => of(null))),
        tables: apiService.getLogEntryTables().pipe(catchError(() => of(null))),
        users: apiService.getLogEntryUsers().pipe(catchError(() => of(null)))
    }).pipe(map(({customers, tables, users}) => ({
        customers: customers ?? [],
        tables: tables ?? [],
        users: users ?? [],
        failedLists: [
            ...(customers ? [] : ["customer"]),
            ...(tables ? [] : ["table"]),
            ...(users ? [] : ["changed by"])
        ]
    })));
};
